import _ from 'lodash';
import storageLocationApi from '@/api/storageLocationApi';
import { fetchOnce } from '@/store/utils/fetchOnce';
import config from '@/config/env-constants';

export default {
	namespace: true,

	state: {
		storageLocations: {},
		connectedStorageLocations: {},
		currStorageLocation: {},
		storageLocationsLoaded: false,
		connectedStorageLocationsLoaded: false,
	},

	mutations: {
		SET_ALL_STORAGE_LOCATIONS(state, storageLocations) {
			state.storageLocations = storageLocations
		},
		SET_CONNECTED_STORAGE_LOCATIONS(state, storageLocations) {
			state.connectedStorageLocations = storageLocations;
		},
		SET_CURR_STORAGE_LOCATION(state, storageLocation) {
			state.currStorageLocation = storageLocation
		},
		SET_STORAGE_LOCATIONS_LOADED(state, val) {
			state.storageLocationsLoaded = val;
		},
		SET_CONNECTED_STORAGE_LOCATIONS_LOADED(state, val) {
			state.connectedStorageLocationsLoaded = val;
		},
	},

	actions: {
		setAllStorageLocations(vuexContext, storageLocations) {
			vuexContext.commit('SET_ALL_STORAGE_LOCATIONS', storageLocations);
		},
		setAllConnectedStorageLocations(vuexContext, storageLocations) {
			vuexContext.commit('SET_CONNECTED_STORAGE_LOCATIONS', storageLocations);
		},
		updateAllStorageLocations(vuexContext, newStorageLocations) {
			let storageLocations = vuexContext.getters.storageLocations;

			_.forEach(newStorageLocations, (value, key) => {
				storageLocations[key] = value;
			});

			vuexContext.commit('SET_ALL_STORAGE_LOCATIONS', storageLocations);
		},

		fetchStorageLocationsIfNeeded({ state, getters, commit }, payload = {}) {
			if (state.storageLocationsLoaded) return Promise.resolve();
			return fetchOnce('storageLocations', () => {
				let currUserId = payload.currUserId || getters.loggedUser.id;
				let view = payload.view || (getters.isSuperAdmin ? config.view.ADMIN : config.view.COMPANY);
				let filterBy = payload.filterBy || {
					companyId: getters.loggedUserCompany.id,
					companyAccess: getters.loggedUser.companyAccess,
					includeConnection: true
				};

				return storageLocationApi.getStorageLocations(filterBy, view, currUserId).then(({ data }) => {
					if (data.isSuccess) {
						commit('SET_ALL_STORAGE_LOCATIONS', data.storageLocations);
						commit('SET_STORAGE_LOCATIONS_LOADED', true);

						if (!_.isEmpty(data.connectedStorageLocations)) {
							commit('SET_CONNECTED_STORAGE_LOCATIONS', data.connectedStorageLocations);
							commit('SET_CONNECTED_STORAGE_LOCATIONS_LOADED', true);
						}
					}
					return data;
				});
			});
		},
	},

	getters: {
		storageLocations(state) {
			if (!_.isEmpty(state.storageLocations)) {
				return state.storageLocations;
			}
			return {};
		},
		connectedStorageLocations(state) {
			if (!_.isEmpty(state.connectedStorageLocations)) {
				return state.connectedStorageLocations;
			}
			return {};
		},
		currStorageLocation(state) {
			if (!_.isEmpty(state.currStorageLocation)) {
				return state.currStorageLocation;
			}
			return {};
		}
	}
}
